// extracted by mini-css-extract-plugin
module.exports = {"tagLink":"tag-link_tagLink_1r6"};